import { I18n, I18nType } from '@schemas'

class Menu {
	constructor({
		id = '',
		name = '',
		i18n = [],
		order = 0,
		icon = '',
		path = '',
		uri = '',
		parentId = '',
		folderYn = 1,
		activateYn = 1,
		updatedAt = '',
		updatedBy = '',
		createdAt = '',
	} = {}) {
		this.id = id === null ? '' : id
		this.name = name === null ? '' : name
		this.i18n =
			i18n === null ? [] : (i18n.map(anI18n => new I18n(anI18n)) as any as I18nType[])
		this.order = order === null ? 0 : order
		this.icon = icon === null ? '' : icon
		this.path = path === null ? '' : path
		this.uri = uri === null ? '' : uri
		this.parentId = parentId === null ? '' : parentId
		this.folderYn = folderYn === null ? 1 : folderYn
		this.activateYn = activateYn === null ? 1 : activateYn
		this.updatedAt = updatedAt === null ? '' : updatedAt
		this.updatedBy = updatedBy === null ? '' : updatedBy
		this.createdAt = createdAt === null ? '' : createdAt
	}

	id: string
	name: string
	i18n: I18nType[]
	order: number
	icon: string
	path: string
	uri: string
	parentId: string
	folderYn: number
	activateYn: number
	updatedAt: string
	updatedBy: string
	createdAt: string
}

export { Menu }
